import { render, staticRenderFns } from "./AttendView.vue?vue&type=template&id=4481cdfb"
import script from "./AttendView.vue?vue&type=script&lang=js"
export * from "./AttendView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports